/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import styles from "./profile.module.css";
import { Button, Divider, LoadingOverlay, MultiSelect } from "@mantine/core";
import Axios from "axios";
const host = "/";
const token = localStorage.getItem("token");
const id = localStorage.getItem("id");
import {
  fetchUserApi,
  fetchisInductedApi,
  fetchUpdateDomainsApi,
} from "../../api/user";
import { getDomainList } from "../../api/auth";
import { showNotification } from "@mantine/notifications";
import { getRegistrationStatus } from "../../api/settings";

export const Profile = () => {
  const [isMentor, setIsMentor] = useState(false);
  const [user, setUser] = useState("");
  const [domains, setDomains] = useState([]);
  const [updateDomains, setUpdateDomains] = useState([]);
  const [domainList, setDomainList] = useState([]);
  const [inductedDomains, setID] = useState([""]);
  const [rollno, setRollNo] = useState("");
  const [userLoad, setUserLoad] = useState(false);
  const [regStatus, setRegStatus] = useState(false);
  useEffect(() => {
    // Make api call to get the list
    const getBasicDetails = async () => {
      const domainData = await getDomainList();
      let domainList = [];
      //console.log(domainData);
      for (const domain of domainData.data.domains) {
        domainList = [
          ...domainList,
          { value: `${domain.id}`, label: domain.name },
        ];
      }
      setDomainList(domainList);
    };
    getBasicDetails();
    const fetchSetting = async () => {
      const res = await getRegistrationStatus();
      setRegStatus(res.data.isRegistrationOpen);
      // console.log(res.data.isRegistrationOpen);
    };
    fetchSetting();
  }, []);

  // async function fetchStatus(data) {
  //   const res = await fetchisInductedApi(data).catch((err) => {
  //     showNotification({
  //       title: "ERROR",
  //       message:
  //         err.response != null
  //           ? err.response.data != null
  //             ? err.response.data.message != null
  //               ? err.response.data.message
  //               : err.message
  //             : err.message
  //           : err.message,
  //       color: "red",
  //     });
  //     if (err.response.status == 401 || err.response.status == 403) {
  //       localStorage.clear();
  //       window.location.replace("/");
  //     }
  //     return;
  //   });
  //   if (res == null) return;
  //   if (res.status == 200) {
  //     return res.data;
  //   } else {
  //     showNotification({
  //       title: "ERROR",
  //       message: res.data.message,
  //       color: "red",
  //     });
  //     return;
  //   }
  // }

  async function fetchUser() {
    const res = await fetchUserApi().catch((err) => {
      showNotification({
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        localStorage.clear();
        window.location.replace("/");
      }
      return;
    });
    if (res == null) return;
    if (res.status == 200) {
      // if (domains.length === 1) {
      const userId = res.data.user.id;
      let array = [];
      for (var i = 0; i < res.data.user.domainList.length; i++) {
        const string = res.data.user.domainList[i].name;
        const domID = res.data.user.domainList[i].id;
        array = [...array, string.toString()];
        if (res.data.user.isMentor == false) {
          const data = {
            menteeId: userId,
            domainId: domID,
          };
          try {
            const response = await fetchisInductedApi(data);
            if (response.data.isInducted == true) {
              setID((oldArray) => oldArray.concat(string.toString()));
            }
          } catch (err) {
            //console.log(err.message);
          }
        }
        // }
        setDomains(array);
        setUser(res.data.user.name);
        setRollNo(res.data.user.roll);
        setIsMentor(res.data.user.isMentor);
      }
      return;
    } else {
      showNotification({
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return;
    }
  }

  const handleSubmit = async () => {
    setUserLoad(true);
    if (updateDomains.length > 0) {
      let domainReqList = [];
      //console.log(updateDomains);
      const CommonTask = domainList.find(
        (domain) => domain.label === "Common Task"
      );
      const CommonTaskId = CommonTask ? CommonTask.value : null;
      if (CommonTask && !updateDomains.includes(CommonTaskId)) {
        domainReqList = [...domainReqList, { id: parseInt(CommonTaskId) }];
      }
      for (const domain of updateDomains) {
        domainReqList = [...domainReqList, { id: parseInt(domain) }];
      }

      const data = {
        domainList: domainReqList,
      };
      //console.log(data);
      const res = await fetchUpdateDomainsApi(data).catch((err) => {
        setUpdateDomains([]);
        showNotification({
          title: "ERROR",
          message:
            err.response != null
              ? err.response.data != null
                ? err.response.data.message != null
                  ? err.response.data.message
                  : err.message
                : err.message
              : err.message,
          color: "red",
        });
        if (err.response.status == 401 || err.response.status == 403) {
          localStorage.clear();
          window.location.replace("/");
        }
        setUserLoad(false);
        return;
      });
      if (res == null) return;
      if (res.status == 200) {
        setUpdateDomains([]);
        setUserLoad(true);
        fetchUser().then((res) => {
          setUserLoad(false);
        });
        setUserLoad(false);
        showNotification({
          title: "Domains Updated Succesfully",
          color: "green",
        });
        return res.data;
      } else {
        setUpdateDomains([]);
        setUserLoad(false);
        showNotification({
          title: "ERROR",
          message: res.data.message,
          color: "red",
        });
        return;
      }
    }
    setUserLoad(false);
  };

  useEffect(() => {
    setUserLoad(true);
    fetchUser().then((res) => {
      setUserLoad(false);
    });
  }, []);
  return (
    <div className={styles.profile}>
      <LoadingOverlay visible={userLoad} />
      <div className={styles.row}>
        <h1 className={styles.title}>Profile</h1>
        {isMentor ? <h2 className={styles.mentor}>MENTOR</h2> : <></>}
      </div>
      <div className={styles.row}>
        <h2 className={styles.domaintitle}>Name</h2>
        <p className={styles.domaintitle}>{user}</p>
      </div>
      <Divider />
      <div className={styles.row}>
        <h2 className={styles.domaintitle}>Roll No</h2>
        <p className={styles.domaintitle}>{rollno}</p>
      </div>
      <Divider />
      <div className={styles.domain}>
        <h2 className={styles.domaintitle}>Domains</h2>
        <div>
          {domains.map((domain, index) => (
            <p key={index} className={styles.tab}>
              {domain}
            </p>
          ))}
        </div>
      </div>
      {regStatus ? (
        <>
          <div>
            <MultiSelect
              placeholder="Change your domain(s) of interest"
              data={domainList}
              mt="md"
              searchable
              maxSelectedValues={10}
              creatable={false}
              getCreateLabel={(query) => `+ Create ${query}`}
              onCreate={(query) =>
                setUpdateDomains((current) => [...current, query])
              }
              nothingFound="Nothing found..."
              value={updateDomains}
              onChange={setUpdateDomains}
            />
            <Button onClick={handleSubmit} className={styles.submit}>
              Update
            </Button>
          </div>
        </>
      ) : (
        <></>
      )}

      {/* After Induction Result */}
      {inductedDomains.length > 1 ? (
        <div>
          <Divider />
          <div className={styles.row}>
            <h2 className={styles.domaintitle}>Inducted</h2>
            <div>
              {inductedDomains.slice(1).map((domain, index) => (
                <p key={index} className={styles.tab}>
                  {domain}
                </p>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
